import React, { useEffect } from 'react';

import { ToastLoadingIcon } from '../../assets';
import styles from './toast.module.css';

interface ToastProps {
  message: string;
  duration?: number;
  onClose?: () => void;
  loading?: boolean;
}

const defaultDuration = 2000;

const Toast: React.FC<ToastProps> = ({
  message,
  duration = defaultDuration,
  onClose,
  loading
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={styles.mask}>
      {loading ? (
        <div className={styles.loadingContent}>
          <div className={styles.loadingIconContainer}>
            <ToastLoadingIcon className={styles.loadingIcon} />
          </div>
          <div className={styles.loadingText}>{message}</div>
        </div>
      ) : (
        <div className={styles.content}>{message}</div>
      )}
    </div>
  );
};

export default Toast;
